import { useState, useEffect } from 'react';
import { User } from '../../../types';

export const useFilterAndSort = (users: User[]) => {
  const [filteredUsers, setFilteredUsers] = useState<User[]>([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [orderBy, setOrderBy] = useState<keyof User>('username');
  const [order, setOrder] = useState<'asc' | 'desc'>('asc');

  useEffect(() => {
    const filtered = users.filter(
      (user) =>
        user.username.toLowerCase().includes(searchQuery.toLowerCase()) ||
        (user.email?.toLowerCase() || '').includes(searchQuery.toLowerCase())
    );
    setFilteredUsers(filtered);
  }, [searchQuery, users]);

  const handleSort = (property: keyof User) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
    
    const sorted = [...filteredUsers].sort((a, b) => {
      const valueA = a[property] || '';
      const valueB = b[property] || '';
      return (isAsc ? 1 : -1) * (valueA < valueB ? -1 : valueA > valueB ? 1 : 0);
    });
    setFilteredUsers(sorted);
  };

  return {
    filteredUsers,
    searchQuery,
    setSearchQuery,
    orderBy,
    order,
    handleSort,
  };
}; 